let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9HC2K")).then(() => parcelRequire('eU9tO'));